module.exports = __webpack_public_path__ + "static/media/14_andinvainthedreamer.8b7d60d3.jpg";